import { VideoComponent } from './video.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ VideoComponent });
